"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var discordImg = "/images/promotionalContent/discord.png",
  dcWebLink = "https://discord.gg/RBwHjWz";
function Discord(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "allPromotionContentWrapper"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "bannerImageOfPromotion",
    href: dcWebLink,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      width: "100%"
    },
    src: props.domain + discordImg
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "promotionContentTextWrapper"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "promotionContentText promotionContentTextMargin"
  }, props.i18next.t("lable.joinMygame")), /*#__PURE__*/_react["default"].createElement("a", {
    href: dcWebLink,
    target: "_blank",
    className: "promotionContentText promotionOpenNow",
    style: {
      textDecoration: 'underline',
      display: 'inline-block'
    }
  }, props.i18next.t("lable.openNow"))));
}
var _default = Discord;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/NewDiscord.js
 ** module id = 2389
 ** module chunks = 0
 **/